// Router.tsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import useRoutes from './useRoutes';
import { useProfileNavigation } from '../hooks/useProfileNavigation';

const Router: React.FC = () => {
  const { navListSelected } = useRoutes();
  
  // Handle profile-based navigation
  useProfileNavigation();

  return (
    <Routes>
      {navListSelected.flatMap((item, idx) => {
        if (item.itHasSubmenu && Array.isArray(item.submenuList)) {
          return item.submenuList.map((subItem, subIdx) => (
            <Route
              key={`${idx}-${subIdx}`}
              path={subItem.path}
              element={subItem.isUnavailableConfig ? <Navigate to={subItem.isUnavailableConfig.redirectTo ?? '/'} replace /> : subItem.component}
            />
          ));
        }
        return (
          <Route
            key={idx}
            path={item.path}
            element={item.isUnavailableConfig ? <Navigate to={item.isUnavailableConfig.redirectTo ?? '/'} replace /> : item.component}
          />
        );
      })}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default Router;
